/*
充电成功率--按月呈现
 */
import React, { Component } from "react";
import Echarts from "echarts";
import ScGridTable from "@/components/display/table/gridTableCore";
import { Spin } from "antd";

class ChargeSuccessFirmware extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      btnType: 1, // 按钮状态。 1图2表
      tableConfig: null,
    };
  }

  /**
   * 初始化页面方法
   */
  componentDidMount() {
    // 默认加载
    this.stubIntactChart(this.props.dataSource);
  }

  componentWillMount() {
    // 预设表单配置项，防止gridTableCore初始化失败
    this.initTableConfig(this.props.dataSource);
  }

  /**
   * 父组件参数修改后，子组件调用方法
   */
  componentWillReceiveProps(nextProps) {
    // 如果数据源改变，则重新渲染图表
    if (JSON.stringify(nextProps.dataSource) !== JSON.stringify(this.props.dataSource)) {
      if (this.state.btnType === 1) {
        this.stubIntactChart(nextProps.dataSource);
      } else {
        this.initTableConfig(nextProps.dataSource);
      }
    }
  }

  /** */
  initTableConfig = (dataSource) => {
    this.setState({
      tableConfig: {
        tableKey: "chargeSuccessFirmwareTable",
        tableColumns: [
          {
            name: "版本",
            key: "stubVersionName",
            colType: "tipCol",
            align: "center",
          },
          {
            name: "订单数",
            key: "totalOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "占比",
            key: "orderRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text ? `${text}%` : "--"}`;
            },
          },
          {
            name: "成功订单数",
            key: "successOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "失败订单数",
            key: "failureOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功率",
            key: "successRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: dataSource,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };

  /**
   * 完好率按日期图表展示
   */
  stubIntactChart(dataSource) {
    const dataArry = dataSource; // 接口获取数据

    // 设置X轴
    const xAxisData = dataArry.map((item) => {
      return item.stubVersionName;
    });

    const failList = [];
    const successList = [];
    const rateList = [];
    const successListNoMap = [];
    let allList11 = [];
    // 处理数据源，转换echarts数据
    dataArry.forEach((v) => {
      // let time = Tool.translateTime(v.date, 'YYYY-MM');

      successList.push({
        value: v.successOrder || 0,
        info: {
          totalOrder: v.totalOrder,
          successRate: v.successRate || 0,
        },
      });
      successListNoMap.push(v.successOrder);
      failList.push(v.failureOrder || 0);
      rateList.push(v.successRate || 0);
      allList11.push(v.totalOrder);
    });

    allList11 = allList11.sort((a, b) => Number(b) - Number(a));

    let maxVal = 0;

    if (allList11.length > 0) {
      maxVal = Math.ceil(Number(allList11[0]) / 10) * 10;
    }

    const myChart = Echarts.init(document.getElementById("charge-success-firmware-chart"));
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        backgroundColor: "rgba(0,0,0,.5)",
        show: true,
        formatter: (params) => {
          let str = "";
          if (params[0].axisValue) {
            str += `<div  style="padding:10px 24px 3px 10px">${params[0].axisValue}</div>`;
            str += `<div  style="padding:3px 24px 3px 10px">总订单：${params[1].data.info.totalOrder}，成功率：${params[1].data.info.successRate}%</div>`;
            str += `<div  style="padding:3px 24px 12px 10px">成功订单：${params[1].data.value}，失败订单：${params[0].data}</div>`;
            return str;
          }
        },
        // position: function (pos, params, dom, rect, size) {
        //   // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
        //   var obj = { top: 60 };
        //   obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
        //   return obj;
        // }
      },
      color: ["#CDDAE7", "#5B8FF9"],
      legend: {
        selectedMode: false,
        textStyle: {
          padding: [10, 0],
        },
        top: 0,
        itemGap: 15,
        itemWidth: 21,
        itemHeight: 8,
        data: [
          {
            name: "成功率",
          },
          {
            name: "成功订单",
          },
          {
            name: "失败订单",
          },
        ],
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            // rotate: 35,
            textStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
        },

        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
      ],
      grid: {
        left: "50px",
        right: "50px",
      },
      yAxis: [
        {
          type: "value",
          name: "数量",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: maxVal,
          interval: Math.ceil(maxVal / 10),
          axisLabel: {
            formatter: "{value}",
          },
          nameTextStyle: {
            padding: [0, 25, 10, 0],
            color: "#666",
          },
        },
        {
          type: "value",
          name: "百分比",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: 100,
          interval: 10,
          nameTextStyle: {
            padding: [0, 0, 10, 40],
            color: "#666",
          },
          axisLabel: {
            formatter: "{value}%",
          },
        },
      ],
      series: [
        {
          name: "失败订单",
          type: "bar",
          yAxisIndex: 0,
          stack: "1",
          data: failList,
          barGap: "-100%",
        },
        {
          name: "成功订单",
          type: "bar",
          barWidth: 37,
          yAxisIndex: 0,
          stack: "1",
          barGap: "-100%",
          data: successList,
        },
        {
          name: "成功率",
          type: "line",
          symbol: "none",
          itemStyle: {
            color: "#F7C558",
          },
          yAxisIndex: 1,
          // polarIndex: 2,
          data: rateList,
        },
      ],
      contentToOption: function () {
        // 数据视图刷新的方法
        // this.stubIntactChart();
      },
    };
    myChart.clear();
    myChart.setOption(option);
  }

  btnChange = (type) => {
    this.setState(
      {
        btnType: type,
      },
      () => {
        if (type === 1) {
          this.stubIntactChart(this.props.dataSource);
        } else {
          this.initTableConfig(this.props.dataSource);
        }
      },
    );
  };

  render() {
    return (
      <Spin spinning={this.props.loading}>
        <div className='section'>
          <div className='title-box'>
            <div className='title'>固件版本</div>
            <div className='btn-switch-box'>
              <span
                className={this.state.btnType === 1 && "selected-btn"}
                onClick={() => this.btnChange(1)}>
                图
              </span>
              <span
                className={this.state.btnType === 2 && "selected-btn"}
                onClick={() => this.btnChange(2)}>
                表
              </span>
            </div>
          </div>
          {this.state.btnType === 1 ? (
            <div
              style={{ width: "100%", height: 420, overflowY: "auto" }}
              id='charge-success-firmware-chart'
            />
          ) : (
            <ScGridTable config={this.state.tableConfig} />
          )}
        </div>
      </Spin>
    );
  }
}

export default ChargeSuccessFirmware;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/chargeSuccessFirmware.js